module.exports = {"id":"186146","name":"Danny Welbeck","rating":"79","photo":"./data/images/photos/0/186146.png","club":{"name":"Arsenal","logo":"./data/images/clubs/Arsenal.png"},"positions":["BU","AG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DannyWelbeck0.json
// module id = 965
// module chunks = 0